export const FETCH_ASSIGNMENTS_REQUEST = "fetch/assignments/request";
export const FETCH_ASSIGNMENTS_SUCCESS = "fetch/assignments/success";
export const FETCH_ASSIGNMENTS_FAILURE = "fetch/assignments/failure";
export const FETCH_ASSIGNMENT_REQUEST = "fetch/assignment/request";
export const FETCH_ASSIGNMENT_SUCCESS = "fetch/assignment/success";
export const FETCH_ASSIGNMENT_FAILURE = "fetch/assignment/failure";
export const UPDATE_ASSIGNMENT_REQUEST = "update/assignment/request";
export const UPDATE_ASSIGNMENT_SUCCESS = "update/assignment/success";
export const UPDATE_ASSIGNMENT_FAILURE = "update/assignment/failure";
export const CREATE_ASSIGNMENT_REQUEST = "create/assignment/request";
export const CREATE_ASSIGNMENT_SUCCESS = "create/assignment/success";
export const CREATE_ASSIGNMENT_FAILURE = "create/assignment/failure";
export const DELETE_ASSIGNMENT_REQUEST = "delete/assignment/request";
export const DELETE_ASSIGNMENT_SUCCESS = "delete/assignment/success";
export const DELETE_ASSIGNMENT_FAILURE = "delete/assignment/failure";

export const FETCH_USER_ASSIGNMENTS_REQUEST = "fetch/user/assignments/request";
export const FETCH_USER_ASSIGNMENTS_SUCCESS = "fetch/user/assignments/success";
export const FETCH_USER_ASSIGNMENTS_FAILURE = "fetch/user/assignments/failure";
export const FETCH_USER_ASSIGNMENT_REQUEST = "fetch/user/assignment/request";
export const FETCH_USER_ASSIGNMENT_SUCCESS = "fetch/user/assignment/success";
export const FETCH_USER_ASSIGNMENT_FAILURE = "fetch/user/assignment/failure";
export const CREATE_USER_ASSIGNMENT_REQUEST = "create/user/assignment/request";
export const CREATE_USER_ASSIGNMENT_SUCCESS = "create/user/assignment/success";
export const CREATE_USER_ASSIGNMENT_FAILURE = "create/user/assignment/failure";
export const DELETE_USER_ASSIGNMENT_REQUEST = "delete/user/assignment/request";
export const DELETE_USER_ASSIGNMENT_SUCCESS = "delete/user/assignment/success";
export const DELETE_USER_ASSIGNMENT_FAILURE = "delete/user/assignment/failure";

// export const FETCH_USER_READINGS_REQUEST = "fetch/user/readings/request";
// export const FETCH_USER_READINGS_SUCCESS = "fetch/user/readings/success";
// export const FETCH_USER_READINGS_FAILURE = "fetch/user/readings/failure";
// export const FETCH_USER_READING_REQUEST = "fetch/user/reading/request";
// export const FETCH_USER_READING_SUCCESS = "fetch/user/reading/success";
// export const FETCH_USER_READING_FAILURE = "fetch/user/reading/failure";
// export const UPDATE_USER_READING_REQUEST = "update/user/reading/request";
// export const UPDATE_USER_READING_SUCCESS = "update/user/reading/success";
// export const UPDATE_USER_READING_FAILURE = "update/user/reading/failure";
// export const CREATE_USER_READING_REQUEST = "create/user/reading/request";
// export const CREATE_USER_READING_SUCCESS = "create/user/reading/success";
// export const CREATE_USER_READING_FAILURE = "create/user/reading/failure";
// export const DELETE_USER_READING_REQUEST = "delete/user/reading/request";
// export const DELETE_USER_READING_SUCCESS = "delete/user/reading/success";
// export const DELETE_USER_READING_FAILURE = "delete/user/reading/failure";
// export const START_USER_READING_REQUEST = "start/user/reading/request";
// export const START_USER_READING_SUCCESS = "start/user/reading/success";
// export const START_USER_READING_FAILURE = "start/user/reading/failure";

//export const FETCH_READINGS_REQUEST = "fetch/readings/request";
//export const FETCH_READINGS_SUCCESS = "fetch/readings/success";
//export const FETCH_READINGS_FAILURE = "fetch/readings/failure";
//export const FETCH_READING_REQUEST = "fetch/reading/request";
//export const FETCH_READING_SUCCESS = "fetch/reading/success";
//export const FETCH_READING_FAILURE = "fetch/reading/failure";
export const CREATE_READING_REQUEST = "create/reading/request";
export const CREATE_READING_SUCCESS = "create/reading/success";
export const CREATE_READING_FAILURE = "create/reading/failure";
export const DELETE_READING_REQUEST = "delete/reading/request";
export const DELETE_READING_SUCCESS = "delete/reading/success";
export const DELETE_READING_FAILURE = "delete/reading/failure";
//export const UPDATE_READING_REQUEST = "update/reading/request";
//export const UPDATE_READING_SUCCESS = "update/reading/success";
//export const UPDATE_READING_FAILURE = "update/reading/failure";
